<template>
  <div class="about-page">
    <div class="img-pakam-header">
      <p class="aboutss" style="font-size: 30px;">Pakam</p>
      <p class="aboutss">
        The Pakam software application is an all-inclusive system solution that
        brings waste and its stakeholders to a win-win situation, wherein wastes
        are collected real-time, transaction is activated real-time and
        actionable insight reports are generated real-time.
      </p>
    </div>

    <div class="sanwo-content">
      <p style="color: #000">
        With Pakam recyclable waste becomes wealth and a value chain is
        activated. Pakam system value preposition is hinged on cleaner cities,
        healthier cities, smarter transaction, end-to-end communication and
        value chain enabler.
      </p>

      <router-link :to="{ name: 'Contact' }">
        <a
          class="btn btn-new btn-xl js-scroll-trigger"
          href="#services"
          style="background-color: #A31B1F ; color : #FFFFFF"
          >Learn more</a
        >
      </router-link>
    </div>
  </div>
</template>

<style>
.about-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.abouts {
  display: flex;
  align-items: center;
  justify-content: center;
  font: 24px/35px;
  font-weight: bold;
  width: 50vw;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
#para {
  color: #2d2d2d;
}
.brand-area {
  display: flex;
  justify-content: center;
}
.img-pakam-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 45px;
  justify-content: center;
  align-items: center;
  height: 700px;
  background-attachment: fixed;
  background-position: center;
  position: relative;
  background-repeat: no-repeat;
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url("../assets/img/Pakam.png");
  background-size: cover;
}

.pr {
  text-align: justify;
}

.props {
  padding: 100px 15vw 50px 15vw;
  text-align: justify;
  color: #000 !important;
}

.mission {
  width: 450px;
  padding: 15px;
  color: #2d2d2d;
  font-size: 16px;
  height: 200px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 24px #0000000d;
  border-radius: 15px;
  opacity: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.business {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  padding: 70px;
  color: #2d2d2d;
  font-size: 16px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 24px #0000000d;
  border-radius: 15px;
  opacity: 1;
  height: 185px;
  text-align: center;
}

.touch {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px;
  width: 90vw;
  color: #2d2d2d;
  font-size: 16px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 8px 24px #0000000d;
  border-radius: 15px;
  opacity: 1;
  height: 185px;
  text-align: center;
}

footer {
  width: 100vw;
}
body {
  background: black;
}
</style>

<script>
import router from "../router";

export default {
  name: "Pakam",
  methods: {
    navigate() {
      router.push({ name: "Pakam" });
    },
  },
};
</script>
